import styled, { keyframes } from 'styled-components'
import {
  LocationFilterWrapperProps,
  LocationFilterDropdownProps,
  LocationItemProps,
  LocationTypeTagProps,
} from './LocationFilter.types'

export const LocationFilterWrapper = styled.div<LocationFilterWrapperProps>`
  position: relative;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
`

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;

  input {
    padding-left: 40px;
  }
`

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.colors.text.secondary};
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

export const ClearButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary}33;
  }
`

export const LocationFilterDropdown = styled.div<LocationFilterDropdownProps>`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.default};
  max-height: 300px;
  overflow-y: auto;
  z-index: ${({ theme }) => theme.zIndex.dropdown};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0)' : 'translateY(-8px)')};
  transition: all ${({ theme }) => theme.transitions.default};
  z-index: 1000000;
`

export const LocationList = styled.div`
  padding: 4px;
`

export const LocationItem = styled.div<LocationItemProps>`
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: background ${({ theme }) => theme.transitions.fast};
  background: ${({ $isHighlighted, theme }) =>
    $isHighlighted ? theme.colors.background.secondary : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &:active {
    background: ${({ theme }) => theme.colors.background.tertiary};
  }
`

export const LocationName = styled.span`
  flex: 1;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  line-height: ${({ theme }) => theme.typography.lineHeight.normal};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-right: 8px;
`

const getLocationTypeColor = (type: LocationTypeTagProps['$type']) => {
  const colors = {
    region: '#0294df',
    district: '#6366f1',
    municipality: '#10b981',
    npa: '#f59e0b',
    address: '#ef4444',
  }
  return colors[type] || '#6b7280'
}

export const LocationTypeTag = styled.span<LocationTypeTagProps>`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  color: ${({ $type }) => getLocationTypeColor($type)};
  background: ${({ $type }) => `${getLocationTypeColor($type)}15`};
  padding: 2px 8px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  white-space: nowrap;
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`

export const NoResults = styled.div`
  padding: 16px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
`

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const LoadingSpinner = styled.div`
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary};

  svg {
    animation: ${spin} 1s linear infinite;
  }
`
